export default "__VITE_PUBLIC_ASSET__68c213c7__"